
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cont/login",
      function () {
        return require("private-next-pages/cont/login.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cont/login"])
      });
    }
  